import React, { useState, useEffect } from 'react';
import axios from '../../http'; // Ensure this points to configured axios instance
import { Link } from 'react-router-dom';

const TestHistory = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      // Fetch 'archived' events explicitly, needing include_archived=true
      // Also might want 'completed' if that is a separate terminal state before archive?
      // For now, let's fetch ALL and filter client side OR fetch twice.
      // Based on backend logic:
      // if status=archived provided, we MUST provide include_archived=true

      const res = await axios.get('/api/test-events', {
        params: {
          status: 'archived',
          include_archived: 'true'
        }
      });
      setEvents(res.data);
    } catch (err) {
      console.error(err);
      setError('Failed to load history');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '1000px', margin: '0 auto' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem'
        }}
      >
        <h1>Test History</h1>
        <Link to="/admin/dashboard" className="btn btn-secondary">
          Back to Admin
        </Link>
      </div>

      {error && (
        <div
          style={{
            padding: '1rem',
            background: '#fff5f5',
            color: '#c53030',
            borderRadius: '4px',
            marginBottom: '1rem'
          }}
        >
          {error}
        </div>
      )}

      {loading ? (
        <p>Loading history...</p>
      ) : (
        <div
          style={{
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            overflow: 'hidden'
          }}
        >
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f7fafc', borderBottom: '2px solid #edf2f7' }}>
              <tr>
                <th style={{ padding: '1rem', textAlign: 'left' }}>Event Name</th>
                <th style={{ padding: '1rem', textAlign: 'left' }}>Date</th>
                <th style={{ padding: '1rem', textAlign: 'left' }}>Location</th>
                <th style={{ padding: '1rem', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '1rem', textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.length === 0 ? (
                <tr>
                  <td
                    colSpan="5"
                    style={{ padding: '2rem', textAlign: 'center', color: '#718096' }}
                  >
                    No archived tests found.
                  </td>
                </tr>
              ) : (
                events.map((ev) => (
                  <tr key={ev.id} style={{ borderBottom: '1px solid #edf2f7' }}>
                    <td style={{ padding: '1rem', fontWeight: '500' }}>{ev.name}</td>
                    <td style={{ padding: '1rem' }}>
                      {new Date(ev.event_date).toLocaleDateString()}
                    </td>
                    <td style={{ padding: '1rem' }}>{ev.location || '-'}</td>
                    <td style={{ padding: '1rem' }}>
                      <span
                        style={{
                          padding: '0.25rem 0.5rem',
                          borderRadius: '9999px',
                          fontSize: '0.85rem',
                          background: '#edf2f7',
                          color: '#4a5568'
                        }}
                      >
                        {ev.status}
                      </span>
                    </td>
                    <td style={{ padding: '1rem', textAlign: 'right' }}>
                      <Link to={`/admin/history/${ev.id}`} className="btn btn-sm btn-secondary">
                        View Results
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TestHistory;
